import { POPPABLE_OPTIONS } from '../components/common/AnnotationOptions/AnnotationOptions.constants';
import { CORNER_RADIUS } from '../components/tools/Rect/Rect.constants';
import { SIDES_NUMBER } from '../components/tools/Polygon/Polygon.constants';
import {
  TEXT_ALIGNMENT,
  TEXT_LETTER_SPACING,
  TEXT_LINE_HEIGHT,
} from '../components/tools/Text/TextOptions/TextOptions.constants';

const EPSILON = 0.001;

/**
 * Whether an inspector option reflects a non-default value on the annotation.
 */
export function isAnnotationOptionApplied(annotation, optionName) {
  if (!annotation || !optionName) {
    return false;
  }

  switch (optionName) {
    case POPPABLE_OPTIONS.OPACITY:
      return (annotation.opacity ?? 1) < 1 - EPSILON;
    case POPPABLE_OPTIONS.STROKE:
      return (annotation.strokeWidth ?? 0) > 0;
    case POPPABLE_OPTIONS.SHADOW:
      return (
        (annotation.shadowBlur ?? 0) > 0 ||
        Math.abs(annotation.shadowOffsetX ?? 0) > EPSILON ||
        Math.abs(annotation.shadowOffsetY ?? 0) > EPSILON
      );
    case POPPABLE_OPTIONS.POSITION:
      return false;
    case CORNER_RADIUS:
      return (annotation.cornerRadius ?? 0) > 0;
    case SIDES_NUMBER:
      return (annotation.sides ?? 3) !== 3;
    case TEXT_ALIGNMENT:
      return Boolean(annotation.align && annotation.align !== 'left');
    case TEXT_LETTER_SPACING:
      return (annotation.letterSpacing ?? 0) > 0;
    case TEXT_LINE_HEIGHT: {
      const lineHeight = annotation.lineHeight ?? 1;
      return Math.abs(lineHeight - 1) > EPSILON;
    }
    default:
      return false;
  }
}

/** Whether the option supports a reset-to-default control in the popup header. */
export function canResetAnnotationOption(optionName) {
  return Boolean(getAnnotationOptionResetPatch(optionName));
}

/** Redux patch to clear a non-default inspector value. */
export function getAnnotationOptionResetPatch(optionName) {
  switch (optionName) {
    case POPPABLE_OPTIONS.OPACITY:
      return { opacity: 1 };
    case POPPABLE_OPTIONS.STROKE:
      return { strokeWidth: 0 };
    case POPPABLE_OPTIONS.SHADOW:
      return {
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowBlur: 0,
        shadowOpacity: 1,
      };
    case POPPABLE_OPTIONS.POSITION:
      return null;
    case CORNER_RADIUS:
      return { cornerRadius: 0 };
    case SIDES_NUMBER:
      return { sides: 3 };
    case TEXT_ALIGNMENT:
      return { align: 'left' };
    case TEXT_LETTER_SPACING:
      return { letterSpacing: 0 };
    case TEXT_LINE_HEIGHT:
      return { lineHeight: 1 };
    default:
      return null;
  }
}

export default isAnnotationOptionApplied;
